/* eslint-disable @conarti/feature-sliced/layers-slices */
import { GridEventListener } from "@mui/x-data-grid";
import {
  generatePath,
  Outlet,
  useNavigate,
  useParams,
  useMatch,
} from "react-router-dom";
import { useGetAllContractsList } from "src/entities/partnerContracts/model/hooks/useGetAllKindsContractsList";
import { useGetTableColumns } from "src/entities/partnerContracts/model/hooks/useGetTableColumns";
import { IPartnerComplexContractItem } from "src/entities/partnerContracts/model/types";
import { TablePage } from "src/shared/components/Table";
import { routes } from "src/shared/constants/routes.constants";

export const ErpPartnersAgreements = () => {
  const navigate = useNavigate();
  const isIframeRoute = useMatch("/iframe/*");
  const { partner_id } = useParams();
  const { tableColumns } = useGetTableColumns();
  const { rows, isFetching } = useGetAllContractsList({
    partner_id: partner_id!,
  });

  const handleRowClick: GridEventListener<"rowClick"> = ({
    row: { type, id, contract_id },
  }) => {
    if (type === "virtual") {
      navigate(
        generatePath(routes.iframePartnerVirtualContractItem, {
          contract_id: id,
          partner_id,
        }),
      );

      return;
    }
    if (type === "complex") {
      navigate(
        generatePath(routes.iframePartnerComplexContractItem, {
          contract_id: id,
          partner_id,
        }),
      );

      return;
    }
    if (type === "agreement") {
      navigate(
        generatePath(routes.iframePartnerComplexContractAgreement, {
          contract_id: contract_id,
          partner_id,
          agreement_id: id,
        }),
      );
    }
  };

  return (
    <>
      <Outlet />
      <TablePage<IPartnerComplexContractItem>
        disableCellSelectionOnClick
        loading={isFetching}
        disableColumnSelector
        onRowClick={handleRowClick}
        unstable_rowSpanning
        getRowId={(row) => String(row.id) + (row.type ?? "")}
        columns={tableColumns}
        rowCount={rows.length}
        rows={rows}
        hidePagination
        columnVisibilityModel={{ additional: !isIframeRoute }}
      />
    </>
  );
};
